// API Base URL - determine based on how the frontend is served
// When served from nginx (Docker, port 3001), use /api baseURL - nginx proxies and strips /api prefix
// When running React dev server (typically port 3002), connect directly to backend at localhost:8001
export const API_BASE_URL = process.env.REACT_APP_API_URL ||
  (window.location.port === '3002' ? 'http://localhost:8001' : '/api');

export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};

export const API_CONFIG = {
  ENDPOINTS: {
    CLASSIFY_QUERY: '/classify/query',
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      REFRESH: '/auth/refresh',
    },
    FEEDBACK: '/feedback/submit',
  },
};
